import { LOCATION_CHANGE } from 'connected-react-router';
import union from 'lodash/union';

import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import { FETCH_TERMS_AND_CONDITIONS } from '../actions/termsAndConditions';
import {
  ADD_LOCAL_ERROR_CODE,
  SUBMIT_LOGIN_FORM,
  FLUSH_ERRORS,
} from '../actions/loginForm';

const defaultState = {
  status: requestsStatuses.default,
  localErrorCodes: [],
  apiErrorCodes: [],
  termsContent: '',
  isLastLoginFailedAttempt: false,
  submitted: false,
};

export default createReducer(defaultState, {
  [SUBMIT_LOGIN_FORM.failure]: (state, { payload: { apiErrorCodes, isLastLoginFailedAttempt } }) => ({
    ...state,
    status: requestsStatuses.failure,
    apiErrorCodes,
    isLastLoginFailedAttempt,
  }),

  [SUBMIT_LOGIN_FORM.pending]: (state) => ({
    ...state,
    status: requestsStatuses.pending,
  }),

  [SUBMIT_LOGIN_FORM.success]: (state) => ({
    ...state,
    status: requestsStatuses.success,
    localErrorCodes: [],
    apiErrorCodes: [],
    submitted: true,
  }),

  [FETCH_TERMS_AND_CONDITIONS.success]: (state, { payload: { content } }) => ({
    ...state,
    termsContent: content,
  }),

  [FLUSH_ERRORS]: (state) => ({
    ...state,
    status: requestsStatuses.default,
    localErrorCodes: [],
    apiErrorCodes: [],
  }),

  [ADD_LOCAL_ERROR_CODE]: (state, { payload: { errorCode } }) => ({
    ...state,
    localErrorCodes: union(state.localErrorCodes, [errorCode]),
  }),

  [LOCATION_CHANGE]: (state, action) => ({
    ...defaultState,
    submitted: !action.payload.location.pathname.includes('login') && state.submitted,
  }),

});
